import css from './style.module.scss';
import Image from 'next/image';
import { gql } from '../../util/fetchGql';
import PostContent, { POST_CONTENT_FRAGMENT } from '../PostContent';

export const ARTICLE_FRAGMENT = gql`
	fragment Article on post_default_Entry {
		postDate @formatDateTime(format: "jS F Y")
		title
        image {
            url @transform (
                width: 2800
                height: 1400
            )
        }
		postContent {
			...PostContent
		}
	}
    ${POST_CONTENT_FRAGMENT}
`;

export default function Article ({ image: [img], postDate, title, postContent }) {
	return (
		<article className={css.article}>
			<header className={css.header}>
				{img && (
					<Image unoptimized width={1400} height={700} src={img.url} />
				)}
				<div>
					<time>{postDate}</time>
					<h1>{title}</h1>
				</div>
			</header>
			<PostContent postContent={postContent} />
		</article>
	);
}
